import { gql } from "generated-graphql";

export const CREDENTIAL_IMPLEMENTATIONS_FOR_STAFF_QUERY = gql(`
  query CredentialImplementationsForStaff(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    credentialImplementationsForStaff(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      items {
        id
        tenantName
        state
        portalJurisdiction
        portalName
        facilityId
        facilityName
        facilityAddress
        county
        credentialName
        credentialEmail
        credentialInEncamp
        implementationStatus
        credentialStatus
        lastVerifiedAt
        lockHolder
        lockExpiresAt
        seenInPortal
        stateId
        stateIdType
        csmName
        csmEmail
        assigneeName
        assigneeEmail
        mostRecentComment
        mostRecentCommentAt
        notes
        blockedReason
      }
      count
    }
  }
`);
